/* eslint-disable react/prop-types */
import { CustomTooltip } from '@hi/brabus'
import { Info } from '@mui/icons-material'
import { Stack, styled, Typography } from '@mui/material'
import React from 'react'

const StyledTypography = styled(({ ...props }) => <Typography {...props} />)(() => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}))

/**
 * Renders a custom card title component with an optional tooltip.
 *
 * @param {Object} props - The component props.
 * @param {string} props.title - The title text to be displayed.
 * @param {string} props.message - The message to be shown in the tooltip.
 * @returns {React.Element} A Stack component containing the title and an info icon with tooltip.
 */
function CustomCardTitle({ title, message }) {
  return (
    <Stack direction="row" alignItems="flex-start" gap="1rem" height="2.5rem">
      <StyledTypography variant="caption">{title}</StyledTypography>

      <CustomTooltip placement="top" title={title} body={message}>
        <Info
          fontSize="small"
          color="action"
          sx={{
            cursor: 'pointer',
          }}
        />
      </CustomTooltip>
    </Stack>
  )
}

export default CustomCardTitle
